var React = require('react');

function Bang7 (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;}\n"),React.createElement("path",{"className":"st0","d":"M381.6,404.9c19-3,32.8-16.4,40.9-31c16.3-29.4,14.6-72.6-23-99.4c-8.5-6-29-17.4-40.6-23.8l-61.7-34.3\n\tl-28.7,51.7l24.8,13.8l30.1,16.7l0,0l35.7,19.8c8.1,4.5,13.5,16,7.6,26.6c-5.9,10.7-18.4,11.8-26.4,7.3l-33.7-18.7l-28.7,51.7\n\tl39.2,21.8c8.4,4.7,14.2,15.5,7.9,26.8c-6.3,11.3-18.4,11.8-26.8,7.1l-39.2-21.8l-28.7,51.7l39.2,21.8c45.2,25.1,89,10.2,108.2-24.4\n\tC389.1,447.6,390.2,422.8,381.6,404.9","key":1})]);
}

Bang7.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 612 792","style":{"enableBackground":"new 0 0 612 792"},"xmlSpace":"preserve"};

module.exports = Bang7;

Bang7.default = Bang7;
